const ProjectStatusEnum = {
  ACTIVE: 1,
  PENDING: 2,
  CLOSED: 3
}

export default ProjectStatusEnum


// WEBPACK FOOTER //
// ./src/enum/projectStatusEnum.js